import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class FeladatCsoportEditDto extends IdentifiableDto {
	constructor() {
		super();

		this.nev = null;
		this.rovid = null;
		this.fejezet = null;
		this.userGroup = null;
	}

	setup(props) {
		super.setup(props);

		this.nev = props.nev;
		this.rovid = props.rovid;
		this.fejezet = props.fejezet !== null ? props.fejezet : [];
		this.userGroup = props.userGroup;

		return this;
	}
}

export default FeladatCsoportEditDto;
